import { render, staticRenderFns } from "./DoctorPhotoSettingsDialog.vue?vue&type=template&id=25726b1c&scoped=true"
import script from "./DoctorPhotoSettingsDialog.vue?vue&type=script&lang=js"
export * from "./DoctorPhotoSettingsDialog.vue?vue&type=script&lang=js"
import style0 from "./DoctorPhotoSettingsDialog.vue?vue&type=style&index=0&id=25726b1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25726b1c",
  null
  
)

export default component.exports